module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isIEorEdge) ? _c('div', {
    staticClass: "ie-warning"
  }, [_c('h2', {
    staticStyle: {
      "font-weight": "lighter"
    }
  }, [_c('span', {
    staticClass: "icon-warning"
  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.IEWarning.you_are_using_a_IE_or_Edge_to_get')) + "\n    "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "italic"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.IEWarning.a_faster_and_better_experience')))]), _vm._v("\n    " + _vm._s(_vm.$t('vue2.IEWarning.we_recommend_that_you_switch_to_these_browsers')) + ":\n    "), _c('a', {
    staticClass: "text-blue",
    attrs: {
      "href": "https://www.google.com/chrome/",
      "target": "_blank"
    }
  }, [_vm._v("\n      Google Chrome")]), _vm._v("\n    " + _vm._s(_vm.$t('vue2.IEWarning.or')) + "\n    "), _c('a', {
    attrs: {
      "href": "https://www.mozilla.org/firefox/new/",
      "target": "_blank"
    }
  }, [_vm._v("Firefox")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0864a57e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/IEAndEdgeWarning.vue
// module id = 1445
// module chunks = 1